import React from 'react'
import { formatarDataOS } from '../../../utils/date'
import styles from './clientOrderServiceList.module.css'

const STATUS_COLORS: Record<string, string> = {
  AGUARDANDO: 'primary',
  AGENDADO: 'info',
  'EM ANDAMENTO': 'warning',
  FINALIZADO: 'success',
  CANCELADO: 'danger',
}

type Props = {
  orders: any[]
  onOpenDetails: (order: any) => void
}

/** Lista compacta e somente leitura das O.S (nº, título e status), usada para o perfil CLIENTE. */
export function ClientOrderServiceList({ orders, onOpenDetails }: Props) {
  if (!orders || orders.length === 0) {
    return (
      <div className={styles.empty}>
        <i className='bi bi-clipboard-x fs-2x text-gray-400' aria-hidden />
        <span className='text-muted fw-semibold fs-6'>Nenhuma ordem de serviço encontrada.</span>
      </div>
    )
  }

  return (
    <div className={styles.list}>
      {orders.map((order) => {
        const color = STATUS_COLORS[order?.status] || 'secondary'
        const collaborator = order?.collaborators?.length > 0 ? order.collaborators[0].name : 'Não definido'

        return (
          <div
            key={order.id}
            className={`${styles.row} border-${color}`}
            role='button'
            tabIndex={0}
            title='Ver detalhes da O.S.'
            onClick={() => onOpenDetails(order)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                onOpenDetails(order)
              }
            }}
          >
            <div className={styles.main}>
              <span className={styles.number}>Nº {order?.number_order_service ?? '-'}</span>
              <span className={styles.title}>{order?.title || 'Sem título'}</span>
              <span className={`badge badge-light-${color} fw-semibold ${styles.status}`}>
                {order?.status ?? 'Não identificado'}
              </span>
            </div>

            <div className={styles.footer}>
              <span className={styles.meta}>
                <i className='bi bi-calendar-event' aria-hidden />
                <span className={styles.metaLabel}>Início:</span>
                {order?.dateInit ? formatarDataOS(order.dateInit) : 'Não agendado'}
              </span>
              <span className={styles.meta}>
                <i className='bi bi-calendar-check' aria-hidden />
                <span className={styles.metaLabel}>Fim:</span>
                {order?.dateEnd ? formatarDataOS(order.dateEnd) : 'Não agendado'}
              </span>
              <span className={styles.meta}>
                <i className='bi bi-hammer' aria-hidden />
                {collaborator}
              </span>
            </div>
          </div>
        )
      })}
    </div>
  )
}
